import { render, staticRenderFns } from "./NoDate.vue?vue&type=template&id=23bae9de&scoped=true&lang=pug&"
import script from "./NoDate.vue?vue&type=script&lang=js&"
export * from "./NoDate.vue?vue&type=script&lang=js&"
import style0 from "./NoDate.vue?vue&type=style&index=0&id=23bae9de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bae9de",
  null
  
)

export default component.exports